module.exports = {
      id: "palo-english-usage",
      viewBox: "0 0 230 78",
      url: "/" + "svg-sprite-475344759687326ca60b708b4aa20d33.svg#palo-english",
      toString: function () {
        return this.url;
      }
    }